export default __webpack_public_path__ + "static/media/avatar_trex3.7d842021.mp3";